import { useSession } from "../session/hooks";

const EDITOR_ROLE = "Editor";

/**
 * UX-side mirror of the backend's WriteAccessPolicy. Returns true when
 * the signed-in caller carries the `Editor` app role.
 *
 * Posture is least-privilege: while the session probe is in flight (or
 * if it failed), this returns `false`. That keeps the chrome conservative
 * — Save/Delete/Create buttons stay hidden until we have positive proof
 * the user is allowed to use them, rather than flashing-then-disappearing.
 *
 * Authorization is *enforced* by the API. This hook only drives chrome:
 * hide/disable affordances that would otherwise generate predictable 403s.
 */
export function useCanEdit(): boolean {
    const session = useSession();
    if (session.data === undefined) return false;
    return session.data.roles.includes(EDITOR_ROLE);
}
